module.exports = "images/enfants_12.42aa1c50.png";